// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class RegisterAPI extends MainAPI {
	/**
	 * @param {*} registrationDetails - Contains userData and petData during registration
	 */
	async postRegister(registrationDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(registrationDetails.formDetails)
		);
		newFormData.append(
			'profileImage',
			registrationDetails.petImg
		);
		
		return API.post(ENDPOINTS.POST_REGISTER, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}
}

export default new RegisterAPI();
